const tokens = [{
  id: "kusama-asset-hub-substrate-assets-16-aris",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "ARIS",
  decimals: 8,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/aris.svg",
  existentialDeposit: "10000000",
  assetId: "16",
  isFrozen: false,
  chain: {
    id: "kusama-asset-hub"
  }
}, {
  id: "kusama-asset-hub-substrate-assets-1984-usdt",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "USDT",
  decimals: 6,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg",
  existentialDeposit: "100",
  assetId: "1984",
  isFrozen: false,
  chain: {
    id: "kusama-asset-hub"
  },
  coingeckoId: "tether"
}, {
  id: "kusama-asset-hub-substrate-assets-8-rmrk",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "RMRK",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/rmrk.svg",
  existentialDeposit: "10000",
  assetId: "8",
  isFrozen: false,
  chain: {
    id: "kusama-asset-hub"
  },
  coingeckoId: "rmrk"
}, {
  id: "kusama-asset-hub-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "KSM",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ksm.svg",
  existentialDeposit: "3333333",
  chain: {
    id: "kusama-asset-hub"
  },
  coingeckoId: "kusama"
}, {
  id: "kusama-bridge-hub-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "KSM",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/kusama-bridge-hub.svg",
  existentialDeposit: "33333333",
  chain: {
    id: "kusama-bridge-hub"
  },
  coingeckoId: "kusama"
}, {
  id: "kusama-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "KSM",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ksm.svg",
  existentialDeposit: "333333333",
  chain: {
    id: "kusama"
  },
  coingeckoId: "kusama"
}, {
  id: "polkadot-asset-hub-substrate-assets-1337-usdc",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "USDC",
  decimals: 6,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/usd-coin.webp",
  existentialDeposit: "10000",
  assetId: "1337",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "usd-coin"
}, {
  id: "polkadot-asset-hub-substrate-assets-17-wifd",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "WIFD",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/wifd.svg",
  existentialDeposit: "1",
  assetId: "17",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  }
}, {
  id: "polkadot-asset-hub-substrate-assets-1984-usdt",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "USDT",
  decimals: 6,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/usdt.svg",
  existentialDeposit: "10000",
  assetId: "1984",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "tether"
}, {
  id: "polkadot-asset-hub-substrate-assets-23-pink",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "PINK",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/pink.png",
  existentialDeposit: "1",
  assetId: "23",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  }
}, {
  id: "polkadot-asset-hub-substrate-assets-30-ded",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "DED",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ded.svg",
  existentialDeposit: "1",
  assetId: "30",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "dot-is-ded"
}, {
  id: "polkadot-asset-hub-substrate-assets-31337-wud",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "WUD",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/wud.webp",
  existentialDeposit: "10000000",
  assetId: "31337",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  }
}, {
  id: "polkadot-asset-hub-substrate-assets-690-bork",
  type: "substrate-assets",
  isTestnet: false,
  isDefault: true,
  symbol: "BORK",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/bork.svg",
  existentialDeposit: "1",
  assetId: "690",
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  }
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-ajun",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "AJUN",
  decimals: 12,
  existentialDeposit: "1000000000",
  onChainId: '{"parents":1,"interior":{"type":"X1","value":{"type":"Parachain","value":2051}}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/unknown.svg"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-bnc",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "BNC",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/bnc.svg",
  existentialDeposit: "1",
  onChainId: '{"parents":1,"interior":{"type":"X2","value":[{"type":"Parachain","value":2030},{"type":"GeneralKey","value":{"length":2,"data":"hex:0x0001000000000000000000000000000000000000000000000000000000000000"}}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "bifrost-native-coin"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-eq",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "EQ",
  decimals: 9,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/eq.svg",
  existentialDeposit: "100000000000",
  onChainId: '{"parents":1,"interior":{"type":"X1","value":{"type":"Parachain","value":2011}}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "equilibrium-token"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-eqd",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "EQD",
  decimals: 9,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/eqd.svg",
  existentialDeposit: "1000000000",
  onChainId: '{"parents":1,"interior":{"type":"X2","value":[{"type":"Parachain","value":2011},{"type":"GeneralKey","value":{"length":3,"data":"hex:0x6571640000000000000000000000000000000000000000000000000000000000"}}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  }
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-glmr",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "GLMR",
  decimals: 18,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/moonbeam.webp",
  existentialDeposit: "1",
  onChainId: '{"parents":1,"interior":{"type":"X2","value":[{"type":"Parachain","value":2004},{"type":"PalletInstance","value":10}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "moonbeam"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-hdx",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "HDX",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/hydradx.webp",
  existentialDeposit: "1",
  onChainId: '{"parents":1,"interior":{"type":"X2","value":[{"type":"Parachain","value":2034},{"type":"GeneralIndex","value":"bigint:0"}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "hydradx"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-ksm",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "KSM",
  decimals: 12,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/ksm.svg",
  existentialDeposit: "1000000000",
  onChainId: '{"parents":2,"interior":{"type":"X1","value":{"type":"GlobalConsensus","value":{"type":"Kusama"}}}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "kusama"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-myth",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "MYTH",
  decimals: 18,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/mythos.svg",
  existentialDeposit: "10000000000000000",
  onChainId: '{"parents":1,"interior":{"type":"X1","value":{"type":"Parachain","value":3369}}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "mythos"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-vdot",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "vDOT",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/vdot.svg",
  existentialDeposit: "1",
  onChainId: '{"parents":1,"interior":{"type":"X2","value":[{"type":"Parachain","value":2030},{"type":"GeneralKey","value":{"length":2,"data":"hex:0x0900000000000000000000000000000000000000000000000000000000000000"}}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "voucher-dot"
}, {
  id: "polkadot-asset-hub-substrate-foreignassets-weth.e",
  type: "substrate-foreignassets",
  isTestnet: false,
  isDefault: true,
  symbol: "WETH.e",
  decimals: 18,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/coingecko/weth.webp",
  existentialDeposit: "15000000000000",
  onChainId: '{"parents":2,"interior":{"type":"X2","value":[{"type":"GlobalConsensus","value":{"type":"Ethereum","value":{"chain_id":"bigint:1"}}},{"type":"AccountKey20","value":{"key":"hex:0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"}}]}}',
  isFrozen: false,
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "weth"
}, {
  id: "polkadot-asset-hub-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "DOT",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/dot.svg",
  existentialDeposit: "100000000",
  chain: {
    id: "polkadot-asset-hub"
  },
  coingeckoId: "polkadot"
}, {
  id: "polkadot-bridge-hub-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "DOT",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/polkadot-bridge-hub.svg",
  existentialDeposit: "1000000000",
  chain: {
    id: "polkadot-bridge-hub"
  },
  coingeckoId: "polkadot"
}, {
  id: "polkadot-substrate-native",
  type: "substrate-native",
  isTestnet: false,
  isDefault: true,
  symbol: "DOT",
  decimals: 10,
  logo: "https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/tokens/dot.svg",
  existentialDeposit: "10000000000",
  chain: {
    id: "polkadot"
  },
  coingeckoId: "polkadot",
  dcentName: "POLKADOT"
}];

export { tokens };
